module.exports = __webpack_public_path__ + "static/media/Death.0c11aace.png";